import React from "react";
import { Link } from "react-router-dom";
import logoImage from "../../assets/images/logo.png";
import "../../styles/Footer.css";

const USEFUL_LINKS = [
  { label: "About Us", to: "/about" },
  { label: "Terms & Conditions", to: "/terms-and-conditions" },
  { label: "Privacy Policy", to: "/privacy-policy"},
  { label: "Shipping & Returns Policy", to: "/shipping-policy"},
];

const HELP_LINKS = [
  { label: "FAQ", to: "/faq" },
  { label: "Contact Us", to: "/contact" },
  { label: "Share App", action: "share" },
];

const CALL_LINKS = [
  { label: "Canberra: +61 412 345 678", href: "tel:+61412345678" },
  { label: "Sydney: +61 412 345 789", href: "tel:+61412345789" },
];

// ── Icons ─────────────────────────────────────────────
const PhoneIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.5 18.5 19.5 19.5 0 0 1 4.69 11.5 19.79 19.79 0 0 1 1.65 2.72 2 2 0 0 1 3.62 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.54a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

const MapPinIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10C21 17 12 23 12 23S3 17 3 10a9 9 0 1 1 18 0z"/><circle cx="12" cy="10" r="3"/>
  </svg>
);

const ChevronUpIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="18 15 12 9 6 15"/>
  </svg>
);

const ArrowIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
  </svg>
);

export default function Footer() {
  const handleShareApp = async () => {
    const shareData = {
      title: "Easy World",
      text: "Check out Easy World.",
      url: window.location.origin,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(window.location.origin);
        alert("App link copied to clipboard!");
      } else {
        alert(window.location.origin);
      }
    } catch (error) {
      console.log("Share cancelled or failed:", error);
    }
  };

  return (
    <footer className="ft-root">
      <div className="ft-body">
        <div className="ft-container">
          <div className="ft-grid">
            <div className="ft-brand">
              <div className="ft-logo-wrap">
                <img src={logoImage} alt="Easy World" className="ft-logo-img" />
              </div>
              <p className="ft-brand-name">Easy World</p>
              <div className="ft-address">
                <span className="ft-address-icon"><MapPinIcon /></span>
                <div>
                  <div className="ft-address-line">Darling Street, Kingston</div>
                  <div className="ft-address-line">Canberra, Australia</div>
                </div>
              </div>
            </div>

            <div className="ft-col">
              <div className="ft-col-title">Useful Links</div>
              <ul className="ft-list">
                {USEFUL_LINKS.map(({ label, to }) => (
                  <li key={to}>
                    <Link to={to} className="ft-link">
                      <span className="ft-link-arrow"><ArrowIcon /></span>
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="ft-col">
              <div className="ft-col-title">Get Help</div>
              <ul className="ft-list">
                {HELP_LINKS.map((item, index) => (
                  <li key={item.to || item.label || index}>
                    {item.action === "share" ? (
                      <button
                        type="button"
                        className="ft-link ft-link-btn"
                        onClick={handleShareApp}
                      >
                        <span className="ft-link-arrow"><ArrowIcon /></span>
                        {item.label}
                      </button>
                    ) : (
                      <Link to={item.to} className="ft-link">
                        <span className="ft-link-arrow"><ArrowIcon /></span>
                        {item.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div className="ft-col">
              <div className="ft-col-title">Contact Us</div>
              <ul className="ft-list">
                {CALL_LINKS.map(({ label, href }) => (
                  <li key={href}>
                    <a href={href} className="ft-link ft-phone">
                      <span className="ft-link-icon"><PhoneIcon /></span>
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="ft-divider" />

          <div className="ft-bottom">
            <p className="ft-copy">
              © {new Date().getFullYear()} Easy World Pvt. Ltd. All rights reserved.
            </p>
            <p className="ft-dev">
              Designed &amp; developed by{" "}
              <a
                href="https://ableinnovation.com.np/"
                target="_blank"
                rel="noopener noreferrer"
                className="ft-dev-link"
              >
                Able Innovation
              </a>
            </p>
            <button
              className="ft-scroll-top"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              title="Back to top"
            >
              <ChevronUpIcon />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}